import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoSimplified = function LogoSimplified(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.simplified"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Logo",
    clipPath: "url(#clip0_2813_8103)"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "Logo_2",
    clipPath: "url(#clip1_2813_8103)"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M21.4906 7.15989C24.9115 7.15989 27.985 8.66049 30.0696 11.0588C30.7778 11.8627 32.1008 11.3133 31.9939 10.2415C31.927 9.54477 31.7934 8.83467 31.593 8.12456C30.5373 4.34628 27.5173 1.39868 23.7356 0.407212C16.1321 -1.60251 9.29028 4.10511 9.29028 11.4071C9.29028 11.8761 9.31701 12.345 9.37046 12.8005C9.50409 13.859 10.9206 14.1269 11.4283 13.1891C13.3526 9.59836 17.1343 7.15989 21.4906 7.15989Z",
    fill: "#FFA310"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_2",
    d: "M7.16402 10.5093C7.16402 7.08844 8.66368 4.01498 11.0605 1.93036C11.8638 1.22213 11.3149 -0.100797 10.2437 0.00610591C9.53402 0.0729204 8.82436 0.206549 8.11469 0.39363C4.33877 1.46266 1.39301 4.46932 0.402163 8.25102C-1.59292 15.8679 4.11114 22.7097 11.4086 22.7097C11.8772 22.7097 12.3459 22.683 12.8011 22.6295C13.8589 22.4959 14.1267 21.0794 13.1894 20.5716C9.60096 18.6474 7.16402 14.8657 7.16402 10.5093Z",
    fill: "#149EF2"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_3",
    d: "M10.5032 24.8494C7.08428 24.8494 4.01262 23.3497 1.92923 20.9529C1.22141 20.1496 -0.100738 20.6985 0.00610232 21.7697C0.0728775 22.466 0.206428 23.1757 0.406754 23.8853C1.4618 27.6612 4.48004 30.607 8.25952 31.5979C15.8719 33.5929 22.7097 27.8889 22.7097 20.5914C22.7097 20.1228 22.683 19.6541 22.6295 19.1989C22.496 18.1411 21.0804 17.8733 20.5729 18.8106C18.6364 22.4124 14.8569 24.8494 10.5032 24.8494Z",
    fill: "#F20057"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_4",
    d: "M24.8494 21.4968C24.8494 24.9157 23.3497 27.9874 20.9529 30.0708C20.1496 30.7786 20.6985 32.1007 21.7697 31.9939C22.466 31.9271 23.1757 31.7936 23.8853 31.5932C27.6612 30.5382 30.607 27.52 31.5979 23.7405C33.5929 16.1281 27.8889 9.29031 20.5914 9.29031C20.1228 9.29031 19.6541 9.31702 19.1989 9.37044C18.1411 9.50399 17.8733 10.9196 18.8106 11.4271C22.4124 13.3636 24.8494 17.1431 24.8494 21.4968Z",
    fill: "#8252DD"
  })))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_2813_8103"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip1_2813_8103"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))));
};

export { LogoSimplified };
